<template>
	<div class="row clearfix" :style="stylerow">
		<div class="classify-title">{{searchname}}</div>
		<div class="classify-list" :style="style">
			<span class="classify-item" v-for="(item,index) in searchkeyop" :key="index"><span v-bind:class="{'sorting':currentkey!=index,'sorting_asc hover':currentkey==index&&desc=='asc','sorting_desc hover':currentkey==index&&desc=='desc'}" @click="sortby(index,item,$event)">{{item.label}}</span></span>

		</div>
	</div>
</template>

<script>
	export default {
		props: {
			searchname: {
				type: String,
				default: ''
			},
			searchkeys: {
				type: Array,
				default: function () {
					return []
				}
			},
			searchby: {
				type: String,
				default: '年级'
			},
			current: {
				type: Number,
				default: 0
			},
			styleop: {
				type: String,
				default: "width:1090px;"
			},
			stylerowop: {
				type: String,
				default: "width:100%;"
			},
		},
		watch: {
			current(val, oldVal) {
				if(val != oldVal) {
					this.currentkey = val;
					this.$emit('input', this.searchby + ':' + this.searchkeyop[val].key);
				}
			}
		},
		data: function() {
			return {
				style: this.styleop,
				searchkeyop: [],
				stylerow: this.stylerowop,
				currentkey: -1,
				desc: ''

			}
		},
		methods: {
			// 根据状态，设置样式
			getClass(index, current) {
				let classStr = index === current ? 'classify-item active' : 'classify-item';
				return classStr;
			},
			search(index, key) {
				this.currentkey = index;
				if(key == '') {
					this.$emit('input', "");
				} else {
					this.$emit('input', this.searchby + ':' + key);
				}
				this.$emit('callbackload');
			},
			sortby(index, item, event) {
				this.currentkey = index;
				var el = event.target;
				if(el.className == "sorting") {

					this.desc = "asc";
					this.$emit('input', 'orderby:' + item.key + '~asc');

				}
				if(el.className == "sorting_asc hover") {
					this.desc = "desc";
					this.$emit('input', 'orderby:' + item.key + '~desc');

				}
				if(el.className == "sorting_desc hover") {
					this.desc = "asc";
					this.$emit('input', 'orderby:' + item.key + '~asc');

				}

				this.$emit('callbackload');

			}

		},
		mounted() {
			this.searchkeyop = this.searchkeys;
		}
	};
</script>

<style type="text/css" lang="scss" rel="stylesheet/scss">
	//     .row {
	//     width: 100%;
	//     text-indent: 1em;
	//     font-size: 14px;
	//     height: 44px;
	//     line-height: 44px;
	//     color: #666666;
	//     font-weight: normal;
	//     border: 1px solid #ccc;
	//     border-top:none;
	//     .classify-title {
	//     float: left;
	//     color: #333333;
	//     line-height: 44px;
	//     }
	//     .classify-list {
	//     float: left;
	//     width: 1050px;
	//     .classify-item {
	//       cursor: pointer;
	//       margin-left:20px;
	//     a {
	//     font-size: 14px;
	//     line-height: 24px;
	//     color: #666666;
	//     font-weight: normal;
	//     text-decoration: none;
	//     padding: 5px;
	// }
	// }
	// .classify-item.active{
	//   background: #33CCCC;
	//   a{
	//     color: white;
	//   }
	// }
	// }
	// }
	.sorting::after {
		content: "\f0dc";
		margin-left: 5px;
		font-family: fontawesome;
		color: rgba(50, 50, 50, .5);
	}
	
	.sorting:hover::after,
	.sorting_asc:hover::after,
	.sorting_desc:hover::after,
	.sorting.hover::after,
	.sorting_asc.hover::after,
	.sorting_desc.hover::after {
		color: #25aef4;
	}
	
	.sorting_asc::after {
		content: "\f0d8";
		font-family: fontawesome;
		margin-left: 5px;
		color: rgba(50, 50, 50, .5);
	}
	
	.sorting_desc::after {
		content: "\f0dd";
		font-family: fontawesome;
		margin-left: 5px;
		color: rgba(50, 50, 50, .5);
	}
</style>


// WEBPACK FOOTER //
// src/components/sortby/index.vue